import React from 'react';
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationPrevious,
  PaginationNext,
  PaginationEllipsis,
} from './ui/pagination';

const BookPagination = ({ currentPage, totalPages, onPageChange, totalItems, pageSize }) => {
  if (totalPages <= 1) return null;

  const from = Math.min((currentPage - 1) * pageSize + 1, totalItems);
  const to = Math.min(currentPage * pageSize, totalItems);
  const visiblePages = [
    currentPage - 2,
    currentPage - 1,
    currentPage,
    currentPage + 1,
    currentPage + 2,
  ].filter(p => p >= 1 && p <= totalPages);

  const handlePrev = (e) => { e.preventDefault(); if (currentPage > 1) onPageChange(currentPage - 1); };
  const handleNext = (e) => { e.preventDefault(); if (currentPage < totalPages) onPageChange(currentPage + 1); };

  return (
    <div className="flex flex-col items-center gap-2 mt-6">
      <p className="text-sm text-gray-500">
        Showing {from}–{to} of {totalItems}
      </p>
      <Pagination>
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              href="#"
              onClick={handlePrev}
              className={currentPage === 1 ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
            />
          </PaginationItem>

          {/* First page link when not near it */}
          {currentPage > 3 && (
            <PaginationItem>
              <PaginationLink href="#" onClick={(e) => { e.preventDefault(); onPageChange(1); }}>
                1
              </PaginationLink>
            </PaginationItem>
          )}

          {currentPage > 4 && (
            <PaginationItem><PaginationEllipsis /></PaginationItem>
          )}

          {/* Pages around current */}
          {visiblePages.map(p => (
            <PaginationItem key={p}>
              <PaginationLink
                href="#"
                isActive={p === currentPage}
                onClick={(e) => { e.preventDefault(); onPageChange(p); }}
              >
                {p}
              </PaginationLink>
            </PaginationItem>
          ))}

          {currentPage < totalPages - 3 && (
            <PaginationItem><PaginationEllipsis /></PaginationItem>
          )}

          {/* Last page link when not near it */}
          {currentPage < totalPages - 2 && (
            <PaginationItem>
              <PaginationLink href="#" onClick={(e) => { e.preventDefault(); onPageChange(totalPages); }}>
                {totalPages}
              </PaginationLink>
            </PaginationItem>
          )}

          <PaginationItem>
            <PaginationNext
              href="#"
              onClick={handleNext}
              className={currentPage === totalPages ? 'pointer-events-none opacity-50' : 'cursor-pointer'}
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  );
};

export default BookPagination;
